export { default } from './CurrencyLogo'
